import { ButtonPresentationProps } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export const quantityIncrementalButtonProps: ButtonPresentationProps = {
    css: css`
        width: 2rem;
        background-color: inherit;
        border: 1px solid ${getColor("common.border")};
        color: ${getColor("text")};
        padding: 0;
        min-height: 2rem;
        font-weight: ${TYPOGRAPHY.weight.bold};
        font-size: ${TYPOGRAPHY.size.small};
        line-height: ${TYPOGRAPHY.lineHeight.small};
        background-color: ${getColor("common.background")};

        &:disabled {
            color: ${getColor("common.disabledLight")};
            border: 1px solid ${getColor("common.disabledLighter")};
            background-color: ${getColor("common.disabledLighter")}
        }
    `
};

export const quantityDecrementButtonProps: ButtonPresentationProps = {
    ...quantityIncrementalButtonProps,
    css: css`
        ${quantityIncrementalButtonProps.css}
        border-radius: 0.5em 0 0 0.5em;
    `
};

export const quantityIncrementButtonProps: ButtonPresentationProps = {
    ...quantityIncrementalButtonProps,
    css: css`
        ${quantityIncrementalButtonProps.css}
        border-radius: 0 0.5em 0.5em 0;
    `
};